// extracted by mini-css-extract-plugin
export default {"errIconTitle":"src-components-Icon-Warning-css-module__errIconTitle--3soKG"};